import {
  APPROVE_ORDER_NUMBER_BLOCK_ID,
  COLLABORATING_KNO_NAME_BLOCK_ID,
  DECISION_PLACE_BLOCK_ID,
  DURATION_DAYS_BLOCK_ID,
  DURATION_HOURS_BLOCK_ID,
  EVENTS_BLOCK_ID,
  FORM_LINK_TYPE_FIELD_ID,
  HEAD_ORDER_NUMBER_BLOCK_ID,
  INN_LABEL_BLOCK_ID,
  INSPECTION_TARGET_LABEL_BLOCK_ID,
  KIND_BLOCK_ID,
  KNO_ORGANIZATION_BLOCK_ID,
  LEGAL_BASES_TITLE_ID,
  MONTH_BLOCK_ID,
  OBJECTS_BLOCK_ID,
  OGRN_LABEL_BLOCK_ID,
  ORDER_DATE_BLOCK_ID,
  ORDER_NUMBER_BLOCK_ID,
  ORGANIZATION_NAME_BLOCK_ID,
  PROSECUTOR_ORGANIZATION_BLOCK_ID,
  REASONS_TITLE_BLOCK_ID,
  REQUIREMENTS_TITLE_BLOCK_ID,
  SIGNER_FULL_NAME_BLOCK_ID,
  SIGNER_POSITION_BLOCK_ID,
  START_DATE_BLOCK_ID,
  STOP_DATE_BLOCK_ID,
  SUBJECT_TYPE_BLOCK_ID,
  SUPERVISION_TYPE_BLOCK_ID,
  TYPE_BLOCK_ID,
  getChecklistBlockId,
  getCollaboratingOrganizationBlockId,
  getDocumentBlockId,
  getEventBlockId,
  getInspectorBlockId,
  getObjectBlockId,
  getObjectResultBlockId,
  getReasonBlockId,
  getRejectReasonBlockId,
  getResultsCancellationInfoBlockId,
  getViolationBlockId,
  getViolationLawsuitBlockId,
  REJECT_REASON_BLOCK_ID,
  AUDITED_PERSON_AUTHORITY_TITLE_BLOCK_ID,
  FEDERAL_LAW_BLOCK_ID,
  getInspectorErvkBlockId,
} from 'KnmPackage/MainModule/constants/fieldsElementsIds';

import { KnmErpFormFieldsNamesTemplatesEnum } from '../enums/KnmErpFormFieldsNamesTemplatesEnum';

interface IFieldData {
  title: string;
  getScrollElementId: (id?: string) => string;
  getReserveScrollElementId?: (id?: string) => string;
}

export const knmErpFieldsDataByFlatNameMap = (): Record<KnmErpFormFieldsNamesTemplatesEnum[number], IFieldData> => {
  return {
    [KnmErpFormFieldsNamesTemplatesEnum.APPROVE_ORDER_NUMBER]: {
      title: 'Номер приказа',
      getScrollElementId: () => APPROVE_ORDER_NUMBER_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST]: {
      title: 'Проверочный лист',
      getScrollElementId: (id: string) => getChecklistBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_NAME]: {
      title: 'Наименование проверочного листа',
      getScrollElementId: (id: string) => getChecklistBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_ERVK]: {
      title: 'Проверочный лист - Номер и название из ЕРВК',
      getScrollElementId: (id: string) => getChecklistBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_OBJECT]: {
      title: 'Проверочный лист - Объект проведения КНМ',
      getScrollElementId: (id: string) => getChecklistBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.COLLABORATING_KNO_NAME]: {
      title:
        'Наименование органа контроля (надзора), органа муниципального контроля, с которым КНМ проводится совместно (в соответствии с шаблоном плана)',
      getScrollElementId: () => COLLABORATING_KNO_NAME_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATION]: {
      title:
        'Наименование органа контроля (надзора), органа муниципального контроля, с которым КНМ проводится совместно (в соответствии со справочником ФРГУ)',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATION_ORGANIZATION]: {
      title:
        'Наименование органа контроля (надзора), органа муниципального контроля, с которым КНМ проводится совместно (в соответствии со справочником ФРГУ)',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.DECISION_PLACE]: {
      title: 'Место вынесения решения',
      getScrollElementId: () => DECISION_PLACE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.DOCUMENT_TYPE]: {
      title: 'Тип документа',
      getScrollElementId: (id: string) => getDocumentBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.DURATION_DAYS]: {
      title: 'Срок проведения (дней)',
      getScrollElementId: () => DURATION_DAYS_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.DURATION_HOURS]: {
      title: 'Срок проведения (часов)',
      getScrollElementId: () => DURATION_HOURS_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.FORM_LINK_TYPE]: {
      title: 'Основание связывания КНМ',
      getScrollElementId: () => FORM_LINK_TYPE_FIELD_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.EVENT]: {
      title: 'Наименование мероприятия по контролю',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.EVENT_NAME]: {
      title: 'Наименование мероприятия по контролю',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.EVENT_START_DATE]: {
      title: 'Дата начала мероприятия по контролю',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE]: {
      title: 'Дата окончания мероприятия по контролю',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.EVENTS]: {
      title: 'Перечень мероприятий по контролю, необходимых для достижения целей и задач проведения КНМ',
      getScrollElementId: () => EVENTS_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.HEAD_ORDER_NUMBER]: {
      title: 'Номер приказа',
      getScrollElementId: () => HEAD_ORDER_NUMBER_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INN]: {
      title: 'Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: () => INN_LABEL_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTION_TARGET]: {
      title: 'Цели, задачи, предмет КНМ',
      getScrollElementId: () => INSPECTION_TARGET_LABEL_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_FULLNAME]: {
      title: 'ФИО должностного лица, уполномоченного на проведение проверки',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION]: {
      title: 'Должность лица, уполномоченного на проведение КНМ',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_TYPE]: {
      title: 'Тип лица, уполномоченного на проведение КНМ',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_ERVK_FULLNAME]: {
      title: 'ФИО должностного лица, уполномоченного на проведение проверки',
      getScrollElementId: (id: string) => getInspectorErvkBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_ERVK_POSITION]: {
      title: 'Должность лица, уполномоченного на проведение КНМ',
      getScrollElementId: (id: string) => getInspectorErvkBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.FEDERAL_LAW]: {
      title: 'Федеральный закон, в соответствии с которым проводится проверка',
      getScrollElementId: () => FEDERAL_LAW_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SUPERVISION_TYPE_ERVK]: {
      title: 'Вид государственного контроля (надзора)',
      getScrollElementId: () => SUPERVISION_TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION_ERVK]: {
      title: 'Наименование органа контроля',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.KIND]: {
      title: 'Вид КНМ',
      getScrollElementId: () => KIND_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.KIND_ERVK]: {
      title: 'Вид КНМ',
      getScrollElementId: () => KIND_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASONS_ERVK]: {
      title: 'Основания регистрации КНМ',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_TYPE_ERVK]: {
      title: 'Основание регистрации КНМ',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_ORDER_ERVK]: {
      title: 'Поручение',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS]: {
      title: 'Индикатор риска',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASONS_ERP_RISK_INDICATOR]: {
      title: 'Индикатор риска',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION]: {
      title: 'Наименование органа контроля',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.LEGAL_BASES]: {
      title: 'Правовые основания проведения КНМ',
      getScrollElementId: () => LEGAL_BASES_TITLE_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.AUDITED_PERSON_AUTHORITY]: {
      title: 'Полномочия проверяемого лица, реализация которых подлежит проверке',
      getScrollElementId: () => AUDITED_PERSON_AUTHORITY_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.AUDITED_PERSON_AUTHORITY_OBJECT]: {
      title: 'Полномочия проверяемого лица, реализация которых подлежит проверке',
      getScrollElementId: () => AUDITED_PERSON_AUTHORITY_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.MONTH]: {
      title: 'Месяц проведения КНМ',
      getScrollElementId: () => MONTH_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECTS]: {
      title: 'Объекты проведения КНМ',
      getScrollElementId: () => OBJECTS_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT]: {
      title: 'Объект проведения КНМ',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME]: {
      title: 'Наименование объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_ADDRESS]: {
      title: 'Местонахождение объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_ADDRESS_TYPE]: {
      title: 'Тип места объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_OBJECT_TYPE]: {
      title: 'Тип объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS]: {
      title: 'Местонахождение объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS_TYPE]: {
      title: 'Тип места объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE]: {
      title: 'Тип объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_SUPERVISION]: {
      title: 'Вид (виды) контроля (надзора) объекта проведения',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT]: {
      title: 'Результат',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_OBJECT]: {
      title: 'Результат - Объект проведения КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_CREATE_DATE]: {
      title: 'Дата и время составления акта о проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_ADDRESS]: {
      title: 'Место составления акта о проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_ADDRESS_TYPE]: {
      title: 'Тип места составления акта о проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_START_DATE]: {
      title: 'Дата и время начала проведения КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DURATION_DAYS]: {
      title: 'Продолжительность проведения КНМ (Дней) по результату',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DURATION_HOURS]: {
      title: 'Продолжительность проведения КНМ (Часов) по результату',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_FULL_NAME]: {
      title: 'ФИО должностного лица, проводившего КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_POSITION]: {
      title: 'Должность лица, проводившего КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_TYPE]: {
      title: 'Тип лица, проводившего КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_FULL_NAME]: {
      title: 'ФИО должностного лица, присутствовавшего при проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_POSITION]: {
      title: 'Должность лица, присутствовавшего при проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_TYPE]: {
      title: 'Тип лица, присутствовавшего при проведении КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ADDITIONAL_INFO_INFORMATION]: {
      title: 'Сведения о результатах проведения КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ADDITIONAL_INFO_TYPE]: {
      title: 'Тип сведений о результатах проведения КНМ',
      getScrollElementId: (id: string) => getObjectResultBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.OGRN]: {
      title: 'Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: () => OGRN_LABEL_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.ORDER_DATE]: {
      title: 'Дата приказа',
      getScrollElementId: () => ORDER_DATE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.ORDER_NUMBER]: {
      title: 'Номер приказа',
      getScrollElementId: () => ORDER_NUMBER_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.ORGANIZATION_NAME]: {
      title: 'Наименование проверяемого лица',
      getScrollElementId: () => ORGANIZATION_NAME_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.PROSECUTOR_ORGANIZATION]: {
      title: 'Наименование прокуратуры',
      getScrollElementId: () => PROSECUTOR_ORGANIZATION_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASONS]: {
      title: 'Основания регистрации КНМ',
      getScrollElementId: () => REASONS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON]: {
      title: 'Основание регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_LAST_CONDUCTED_DATE]: {
      title: 'Основание регистрации КНМ - Дата',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_TYPE]: {
      title: 'Основание проведения мероприятия',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_TEXT]: {
      title: 'Основание регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_DATE]: {
      title: 'Дата основания регистрации КНМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_NUMBER]: {
      title: 'Номер поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_DATE]: {
      title: 'Дата поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REASON_REQUIREMENT_DETAILS]: {
      title: 'Реквизиты требования',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REJECT_REASON]: {
      title: 'Основание отказа КНМ',
      getScrollElementId: () => REJECT_REASON_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REJECT_REASON_TEXT]: {
      title: 'Основание отказа КНМ',
      getScrollElementId: (id: string) => getRejectReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REJECT_REASON_TYPE]: {
      title: 'Тип основания отказа КНМ',
      getScrollElementId: (id: string) => getRejectReasonBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.REQUIREMENTS]: {
      title: 'Подлежащие проверке обязательные требования',
      getScrollElementId: () => REQUIREMENTS_TITLE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.RESULT_CANCELLATION_INFO]: {
      title: 'Сведения об отмене результатов КНМ',
      getScrollElementId: (id: string) => getResultsCancellationInfoBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.RESULT_CANCELLATION_INFO_INFORMATION]: {
      title: 'Сведения об отмене результатов КНМ',
      getScrollElementId: (id: string) => getResultsCancellationInfoBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.RESULT_CANCELLATION_INFO_RESULT]: {
      title: 'Сведения об отмене результатов КНМ - Результат',
      getScrollElementId: (id: string) => getResultsCancellationInfoBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SIGNER_FULL_NAME]: {
      title: 'ФИО подписанта',
      getScrollElementId: () => SIGNER_FULL_NAME_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SIGNER_POSITION]: {
      title: 'Должность подписанта',
      getScrollElementId: () => SIGNER_POSITION_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.START_DATE]: {
      title: 'Дата начала КНМ',
      getScrollElementId: () => START_DATE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.STOP_DATE]: {
      title: 'Дата окончания КНМ',
      getScrollElementId: () => STOP_DATE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SUBJECT_TYPE]: {
      title: 'Тип субъекта КНМ',
      getScrollElementId: () => SUBJECT_TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SUBJECT_TYPE_ERVK]: {
      title: 'Тип субъекта КНМ',
      getScrollElementId: () => SUBJECT_TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.SUPERVISION_TYPE]: {
      title: 'Вид государственного контроля (надзора)',
      getScrollElementId: () => SUPERVISION_TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.TYPE]: {
      title: 'Характер КНМ',
      getScrollElementId: () => TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.TYPE_ERVK]: {
      title: 'Характер КНМ',
      getScrollElementId: () => TYPE_BLOCK_ID,
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION]: {
      title: 'Выявленное нарушение',
      getScrollElementId: (id: string) => getViolationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_RESULT]: {
      title: 'Выявленное нарушение - Результат',
      getScrollElementId: (id: string) => getViolationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_TYPE]: {
      title: 'Характер выявленного нарушения',
      getScrollElementId: (id: string) => getViolationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_NOTE]: {
      title: 'Сведения о выявленном нарушении',
      getScrollElementId: (id: string) => getViolationBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT]: {
      title: 'Меры, принятые по результатам КНМ',
      getScrollElementId: (id: string) => getViolationLawsuitBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_VIOLATION]: {
      title: 'Меры, принятые по результатам КНМ - Нарушение',
      getScrollElementId: (id: string) => getViolationLawsuitBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_ITEM_LAWSUIT_TYPE]: {
      title: 'Тип сведений о выявленном нарушении',
      getScrollElementId: (id: string) => getViolationLawsuitBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_ITEM_TEXT]: {
      title: 'Сведения о выявленном нарушении',
      getScrollElementId: (id: string) => getViolationLawsuitBlockId(id),
    },
    [KnmErpFormFieldsNamesTemplatesEnum.INTERACTION_CATEGORY]: {
      title: 'Категория взаимодействия',
      getScrollElementId: (id: string) => getViolationLawsuitBlockId(id),
    },
  };
};
